import React, { useContext } from 'react';
import DownloadLink from './DownloadLink';

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { AbilityContext, Can } from '../../../../_contexts/AbilitiesContext'
import { useSelector } from 'react-redux';

export default function CompletedActions({ telehealth }) {
  const currentUser = useSelector(state => state.user.currentUser);
  const abilities = useContext(AbilityContext)

  const hasRoomAccess = () => {
    return currentUser.UserType.Name === 'Licensed' || abilities.can('room-access', 'telehealth')
  }

  return <div>
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/telehealth/${telehealth.id}/view`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
    &nbsp;

    <DownloadLink telehealth={telehealth} small />
    &nbsp;

    { hasRoomAccess() &&
      <OverlayTrigger placement="top" overlay={<Tooltip>Encounter</Tooltip>} >
        <Link className="btn btn-outline-primary btn-sm" to={`/telehealth/${telehealth.id}`}><i className="fas fa-laptop-medical"></i></Link>
      </OverlayTrigger>
    }

  </div>
}